// extracted by mini-css-extract-plugin
export default {"inviteCode":"ShowInviteCodeModal_inviteCode__WUXCn"};